import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import Citas from "../assets/img/Citas.png";
import mario from "../assets/img/mario.png";
import Products from "../assets/img/Products.png";
import rick from "../assets/img/rick.png";
import space from "../assets/img/space.png";
import "animate.css";
import TrackVisibility from "react-on-screen";
import pokemon from "../assets/img/pokemon.png";

export const Projects = () => {
  const projects = [
    {
      title: "Appointment App",
      description: "JavaScript, ReactJs",
      imgUrl: Citas,
      url: "https://appointment-app-pi.vercel.app/",
    },
    {
      title: "Space Game",
      description: "JavaScript, HTML, Css",
      imgUrl: space,
      url: "https://space-game-five.vercel.app/",
    },
    {
      title: "Product List ",
      description: "React, Redux, Rest Api, Axios",
      imgUrl: Products,
      url: "https://product-list-mu.vercel.app/",
    },
    {
      title: "Rick y Morty App",
      description: "React, Redux",
      imgUrl: rick,
      url: "https://rickymorty-eight.vercel.app/",
    },
    {
      title: "Pokemon App",
      description: "React, Redux, Rest Api, Axios, SQL, PostgreSQL, NODEJS",
      imgUrl: pokemon,
      url: "https://deploy-phi-seven.vercel.app/",
    },
    {
      title: "Mario Page",
      description: "Tailwind Css",
      imgUrl: mario,
      url: "https://mario-tailwind.vercel.app/",
    },
  ];

  return (
    <section className="projects" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    These are some of the projects I have worked on, I have used
                    different technologies that are described when you place the
                    mouse over the image of the project, let me know which one
                    you found more interesting!
                  </p>
                  {/* <h3>Filter by technologies</h3>
                  <button>React</button>
                  <button>NodeJS</button>
                  <button>Java</button> */}
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    ></Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
